import styled from '@emotion/styled';

const Divider = styled('div')`
  width: 100%;
  height: ${prop => prop.height || '1px'};
  border-bottom-width: ${prop => prop.height || '1px'};
  border-bottom-style: ${prop => prop.variant || 'solid'};
  border-bottom-color: var(--phoenix-${prop => prop.color || 'gray-200'});
`;

export default Divider;
